/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState } from "react";
import {
  CampaignCard,
  CampaignText,
  HorizontalLine,
  CampaignCost
} from "../BookingOverview.styled";
import Actions from "../../../../../Actions";
import { PICTURE_PRICE, VIDEO_PRICE } from "../../utils/constants";
import { CreativeImages } from "./Section.styled";
import { useTranslation } from "react-i18next";
import { numberFormat } from "../../../../../utils/Helpers";
import { Collapse } from "../../../../../Components/Layout";
import { BookingCollapse } from "../utils/BookingCollapse";
import { isVideo } from "../../../Previews/utils";

export const AssetsSection = ({ allCreativeAssets, type = "images" }) => {
  const { t } = useTranslation();
  const [collapse, setCollapse] = useState(true);

  const openImageModal = (event, media, isVideoAsset = false) => {
    event.stopPropagation();
    Actions.toggleModal("showGenericModal", true, {
      headline: t("Licensed images"),
      customWidth: "auto",
      view: (
        <div style={{ padding: "15px", textAlign: "center" }}>
          {isVideoAsset ? (
            <video src={media} alt="video preview" controls muted />
          ) : (
            <img src={media} alt="image preview" />
          )}
        </div>
      )
    });
  };

  const assetTypeLabel = type === "videos" ? t("Licensed videos") : t("Licensed images");
  const assetLabel = type === "videos" ? t("Video") : t("Picture");
  const assetPluralLabel = type === "videos" ? t("Videos") : t("Pictures");

  const assetPrice = type === "videos" ? VIDEO_PRICE : PICTURE_PRICE;

  return (
    <CampaignCard onClick={() => setCollapse(!collapse)}>
      <Collapse
        parent={
          <BookingCollapse
            collapse={collapse}
            title={assetTypeLabel}
            dataTip={t("Price is per asset per campaign. Only to be used with TalentBait")}
            cost={
              <>
                <div>{`${allCreativeAssets.length} ${
                  allCreativeAssets.length === 1 ? assetLabel : assetPluralLabel
                } x ${assetPrice} €`}</div>
                {numberFormat(allCreativeAssets.length * assetPrice)}
              </>
            }
          />
        }
        show={collapse}
      >
        <CampaignText>
          <CreativeImages>
            {allCreativeAssets.map((media, index) => {
              const isVideoAsset = isVideo(media);
              return isVideoAsset ? (
                <video
                  key={index}
                  onClick={(event) => openImageModal(event, media, isVideoAsset)}
                  src={media}
                  alt={`creative video ${index}`}
                  muted
                  autoPlay
                  loop
                />
              ) : (
                <img
                  key={index}
                  onClick={(event) => openImageModal(event, media, isVideoAsset)}
                  src={media}
                  alt={`creative image ${index}`}
                />
              );
            })}
          </CreativeImages>
        </CampaignText>
        <HorizontalLine />
        <CampaignCost>
          <div>{`${allCreativeAssets.length} ${
            allCreativeAssets.length === 1 ? assetLabel : assetPluralLabel
          } x ${assetPrice} €`}</div>
          {numberFormat(allCreativeAssets.length * assetPrice)} €
        </CampaignCost>
      </Collapse>
    </CampaignCard>
  );
};
